"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListGroupComponents = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Checkbox = require("../Checkbox/Checkbox");

var _svg = require("../../svg");

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _listGroup = require("./listGroup.style");

var _generateRandomId = require("../../utils/generateRandomId");

var _TextInput = require("../Inputs/TextInput");

var _MultipleButtons = require("../MultipleButtons/MultipleButtons");

var _listGroupUtils = require("./listGroup-utils");

var _validator = require("../../utils/validator");

var _convertDigits = require("../../utils/convertDigits");

var _MultipleDL = _interopRequireDefault(require("../MultipleDL/MultipleDL"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ListGroupComponents = function ListGroupComponents(_ref) {
  var _item$value;

  var item = _ref.item,
      select = _ref.select,
      limit = _ref.limit,
      state = _ref.state,
      option = _ref.option,
      onChange = _ref.onChange;
  var randomId = (0, _generateRandomId.generateRandomId)(5);
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _listGroup.useStyles)({
    size: "sm",
    flag: true
  });

  var _useState = (0, _react.useState)(item.checked),
      _useState2 = _slicedToArray(_useState, 2),
      checked = _useState2[0],
      setChecked = _useState2[1];

  var _useState3 = (0, _react.useState)((_item$value = item.value) !== null && _item$value !== void 0 ? _item$value : ''),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  (0, _react.useEffect)(function () {
    if (item.checked) handleCheckedItem(true, 'multiple', item.children);
  }, []);

  function handleCheckedItem(isCheck, type, arr) {
    if (!isCheck || limit >= state && limit >= arr.length + state) {
      if (type === 'multiple') setChecked(isCheck);
      select(isCheck, arr);
    }
  }

  function handleOnChangeOption(item, value, type) {
    if (type === 'input') {
      item.value = value.split(',').join('');
      setValue(value);
    } else {
      item.valueUnit = value;
    }

    onChange(!(0, _validator.isEmpty)(value), [item]);
  }

  function handleOnClickDropdown(item, obj, type) {
    if (type === 'add') {
      item.items.push(obj);
    } else {
      item.items = item.items.filter(function (row) {
        return row.id !== obj.id;
      });
    }

    onChange(true, [item]);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.tab
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "radio",
    id: item.id + randomId,
    className: classes.input,
    name: "rd"
  }), /*#__PURE__*/_react["default"].createElement("label", {
    className: classes.tabLabel,
    htmlFor: item.id + randomId
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
    onChange: function onChange(e) {
      return handleCheckedItem(!checked, 'multiple', item.children.length ? item.children : [item]);
    },
    size: "sm",
    label: item.title,
    checked: checked
  }), option && option.input && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.option
  }, /*#__PURE__*/_react["default"].createElement(_TextInput.TextInput, {
    onChange: function onChange(e) {
      return handleOnChangeOption(item, e.target.value, 'input');
    },
    value: (0, _convertDigits.toPersianDigits)((0, _convertDigits.toCurrencyFormat)(value)),
    size: "xs",
    type: "text",
    placeholder: "\u0642\u06CC\u0645\u062A \u067E\u0627\u06CC\u0647",
    margin: false,
    inputOption: /*#__PURE__*/_react["default"].createElement(_MultipleButtons.MultipleButtons, {
      items: _listGroupUtils.INITIAL_PARCEL_VALUE,
      onClick: function onClick(v) {
        return handleOnChangeOption(item, v.unit, 'valueUnit');
      },
      size: "xs"
    })
  })), option && option.dropdown && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.option, " ").concat(classes.optionMargin)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.space
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: ""
  }, /*#__PURE__*/_react["default"].createElement(_MultipleDL["default"], {
    items: option.dropdown.items,
    label: "\u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F",
    onSelect: function onSelect(obj) {
      return handleOnClickDropdown(item, obj, 'add');
    },
    onRemove: function onRemove(obj) {
      return handleOnClickDropdown(item, obj, 'remove');
    },
    size: "xs",
    selectedItems: item.items
  })))), !option && (item.children.length ? /*#__PURE__*/_react["default"].createElement("i", {
    className: classes.arrow,
    id: item.id
  }, _svg.arrow) : '')), item.children.length ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.tabContent
  }, item.children.map(function (child, index) {
    return /*#__PURE__*/_react["default"].createElement(Children, {
      child: child,
      itemChecked: checked,
      limit: limit,
      state: state,
      key: index,
      onChange: function onChange(isCheck, child) {
        return handleCheckedItem(isCheck, 'single', child);
      }
    });
  })) : '');
};

exports.ListGroupComponents = ListGroupComponents;

var Children = function Children(_ref2) {
  var child = _ref2.child,
      itemChecked = _ref2.itemChecked,
      onChange = _ref2.onChange,
      limit = _ref2.limit,
      state = _ref2.state;
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _listGroup.useStyles)({
    size: "sm",
    flag: true
  });

  var _useState5 = (0, _react.useState)(child.checked || itemChecked),
      _useState6 = _slicedToArray(_useState5, 2),
      checked = _useState6[0],
      setChecked = _useState6[1];

  (0, _react.useEffect)(function () {
    setChecked(itemChecked);
  }, [itemChecked]);

  function handleChecked(isCheck, child) {
    if (!isCheck || limit > state) {
      setChecked(!checked);
      onChange(isCheck, child);
    }
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.childrenItem
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
    onChange: function onChange(e) {
      return handleChecked(!checked, [child]);
    },
    size: "sm",
    label: child.title,
    checked: checked
  }));
};